import { object, string } from '@gogame/schemas';

import {
  DATA_PERIOD,
  PAY_TO,
  COMPARE_PERIOD,
  LAST_7_DAYS,
  PERIODS_LAST_DAY,
  PERIOD_TYPE,
} from './constants';

export const periodsValidationSchema = object({
  [DATA_PERIOD]: string().default(LAST_7_DAYS),
  [PAY_TO]: string().default(PERIODS_LAST_DAY),
  [COMPARE_PERIOD]: string(),
  [PERIOD_TYPE]: string(),
});
